/* eslint-disable no-fallthrough */
import React, { useEffect, useState } from 'react'
import { Row, Col, DatePicker, Select } from "antd"
import { BP, Errors, ErrorToday, TrayScanned, Rejected, AverageTime, BraceletScanned, ManualTray } from "../activityCardsUtils/ActivityCardsUtils"
import DetectedErrorFilter from './DetectedErrorFilter'
import ControledTrayChart from '../charts/ControledTrayChart'
import ErrorChart from '../charts/ErrorChart'
import PerformanceChart from '../charts/PerformanceChart'
import { getCountCurrentBP } from '../../api/BPTable/BPTableMethods'
import { getCountTrayError, getCountTray, getCountTrayMonth, getRejectedRate } from "../../api/trayTable/TrayTableMethods"
import { IRejectedRate, STATUS } from '../interface/interface'
import { getErrorsByType, getPerformanceErr, getAverageTime } from '../../api/errors/errors'
import moment, { Moment } from 'moment'
import 'moment/locale/fr';
import locale from 'antd/es/date-picker/locale/fr_FR';

var curr = new Date()

curr.setDate(0);
curr.setMonth(curr.getMonth() - 1)
var start = curr
curr = new Date()
curr.setDate(1)
curr.setMonth(curr.getMonth() + 3)
var end = curr

interface Props {
  range: { start: Moment | null | undefined, end: Moment | null | undefined }
}

const ActivityCard = ({ range }: Props) => {
  const [selectedDate, setSelectedDate] = useState<{ start: Date | undefined, end: Date | undefined }>({ start: start, end: end })
  const [bpLoading, setBpLoading] = useState<boolean>(false)
  const [bpCount, setBpCount] = useState<{ count: number }>({ count: 0 })

  const [errorLoading, setErrorLoading] = useState<boolean>(false)
  const [errorCount, setErrorCount] = useState<{ count: number }>({ count: 0 })

  const [trayLoading, setTrayLoading] = useState<boolean>(false)
  const [trayCount, setTrayCount] = useState<{ count: number, braceletCount: number, forced: number, manual: 0 }>({ count: 0, braceletCount: 0, forced: 0, manual: 0 })

  const [volumeTray, setVolumeTray] = useState<any>(undefined)

  const [countErrLoading, setCountErrLoading] = useState<boolean>(false)

  const [rejected, setRejected] = useState<IRejectedRate | undefined>(undefined)
  const [rejectedLoading, setRejectedLoading] = useState<boolean>(false)

  const [detectedErrorDate, setDetectedErrorDate] = useState<moment.Moment | undefined>(moment(new Date()))
  const [selectedFilter, setSelectedFilter] = useState<string[]>(['wrong count', 'wrong sku', 'lisibility', 'other'])
  const [errors, setErrors] = useState<any>(undefined)

  const [selected, setSelected] = useState<string>("1")

  const [perfomanceDate, setPerformanceDate] = useState<moment.Moment>(moment(new Date()))
  const [perfomance, setPerformance] = useState<any>(undefined)

  const [setup, setSetup] = useState<boolean>(false)
  const [description, setDescription] = useState<string>("")

  useEffect(() => {
    if (!range.start && !range.end) return
    bpCurrent()
    errorTray()
    getData()
    getVolumeTray()
    rejectedRate()
  }, [range])

  const getVolumeTray = async () => {
    if (setup) {
      const res = await getCountTrayMonth(range)
      setVolumeTray(res)
      setDescription(`Nombre de plateaux scannés de ${moment(range.start).format('MM/YYYY')} au ${moment(range.end).format('MM/YYYY')}`)
    } else {
      const res = await getCountTrayMonth()
      let currentDate = new Date()
      const dateMinus3Months = new Date(new Date(currentDate).setUTCHours(0, 1, 0, 0));
      dateMinus3Months.setMonth(currentDate.getMonth() - 5);
      setDescription(`Nombre de plateaux scannés de ${moment(dateMinus3Months).format('MM/YYYY')} à ${moment(currentDate).format('MM/YYYY')}`)
      setVolumeTray(res)
      setSetup(true)
    }
  }

  const bpCurrent = async () => {
    setBpLoading(true)
    const data: any = await getCountCurrentBP(undefined, range)
    setBpCount(data)
    setBpLoading(false)
  }

  const errorTray = async () => {
    setErrorLoading(true)
    const error: any = await getCountTrayError(range)
    setErrorCount(error)
    setErrorLoading(false)
  }

  const getData = async () => {
    setTrayLoading(true)
    let tray: any = await getCountTray(undefined, range)
    setTrayCount(tray)
    setTrayLoading(false)
  }

  const getPerformance = async () => {
    const perf = await getPerformanceErr(perfomanceDate)
    setPerformance(perf)
  }

  const rejectedRate = async () => {
    setRejectedLoading(true)
    const res = await getRejectedRate(range.start, range.end)
    console.log(res)
    if (res) {
      setRejected(res[0])
    }
    setRejectedLoading(false)
  }

  const Error = () => (
    <Row style={{ height: '100%' }}>
      <Col md={24} lg={16} className='max-card'>
        <div style={{ maxHeight: '16rem' }}>
          <div className='global-view-card-title'>Erreurs détectées</div>
          <ErrorChart errors={errors} />
        </div>
      </Col>
      <Col md={24} lg={8} className='max-card'>
        <div className='error-filter-title'>Filtrer par</div>
        <DatePicker locale={locale} picker='year' onChange={(event) => {
          if (event)
            setDetectedErrorDate(event)
        }}
          format="YYYY"
          value={detectedErrorDate}
        />
        <DetectedErrorFilter selectedDate={setDetectedErrorDate} setSelectedDate={setSelectedDate} selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter} />
      </Col>
    </Row>
  )

  const Performance = () => (
    <Row>
      <Col xs={17}>
        <div style={{ maxHeight: '16rem' }}>
          Performance résolution d'erreurs
          <PerformanceChart performance={perfomance} date={perfomanceDate} />
        </div>
      </Col>
      <Col xs={6}>
        <div style={{ paddingTop: '2rem' }}>
          <h2>Periode</h2>
          <DatePicker locale={locale} format={"YYYY - w"} picker='week' onChange={(event) => {
            if (event)
              setPerformanceDate(event)
          }}
            allowClear={false}
            value={perfomanceDate}
          />
        </div>
      </Col>
    </Row>
  )

  return (
    <>
      <Row justify='space-between'>
        <Col className="global-view-card" xs={24} md={11} lg={2}><BP count={bpCount} loading={bpLoading} /></Col>
        <Col className='global-view-card' xs={24} md={11} lg={2}><BraceletScanned count={trayCount} loading={trayLoading} /></Col>
        <Col className='global-view-card' xs={24} md={11} lg={2}><TrayScanned count={trayCount} loading={trayLoading} /></Col>
        <Col className='global-view-card' xs={24} md={11} lg={2}><ErrorToday count={trayCount} loading={countErrLoading} /></Col>
        <Col className='global-view-card' xs={24} md={11} lg={2}><ManualTray count={trayCount} loading={trayLoading} /></Col>
        <Col className="global-view-card" xs={24} md={11} lg={2}><Rejected percent={rejected} loading={rejectedLoading} setSelected={setSelected} selected={selected} /></Col>
      </Row>
      <Row justify='space-between'>
        <Col className="global-view-card" xs={24} md={24} lg={24}>
          <div style={{ display: "flex", padding: "1rem", fontSize: "1.1rem", fontWeight: "bold" }}>
            {description}
          </div>
          <Row justify='space-between' style={{ height: '100%' }}>
            {volumeTray &&
              <ControledTrayChart data={volumeTray} />
            }
          </Row>
        </Col>
      </Row>
      {/* <Row>
        <Col className="card-error" xs={24}>
          <Error />
        </Col>
      </Row>
      <Row justify='space-between'>
        <Col className="card-error" xs={24} md={24} lg={17}><Performance /></Col>
        <Col className="card-error" xs={24} md={24} lg={6}><AverageTime average={average ? average : "0"} setAverageDate={setAverageDate} averageDate={averageDate} /></Col>
      </Row> */}
    </>
  )
}

export default ActivityCard